let currentURL = '' 
const domin = window.location.hostname 
if(domin.includes('cdjm')) {
    currentURL = 'cdjm'
} else if(domin.includes('aqjp')) {
    currentURL = 'aqjp'
} else if(domin.includes('tajp')) {
    currentURL = 'tajp'
} else if(domin.includes('hzjp')) {
    currentURL = 'hzjp'
} else {
    currentURL = 'localhost'
}

export default currentURL
